import { apiClient } from '../lib/api';
import { ENDPOINTS } from './endpoints';

export interface BillingStatus {
  subscriptionStatus: string | null;
  trialEndsAt: string | null;
  currentPeriodEnd: string | null;
  daysLeft: number | null;
  hasActiveAccess: boolean;
  hasStripeCustomer: boolean;
}

export async function getBillingStatus(): Promise<BillingStatus> {
  const res = await apiClient.get<BillingStatus>(ENDPOINTS.billing.status);
  return res.data;
}

export async function createCheckoutSession(): Promise<string> {
  const res = await apiClient.post<{ url: string }>(ENDPOINTS.billing.checkoutSession);
  return res.data.url;
}

export async function createPortalSession(): Promise<string> {
  const res = await apiClient.post<{ url: string }>(ENDPOINTS.billing.portalSession);
  return res.data.url;
}
